angular.module('elfium').service('elfiumUrlService', ['$window', function ($window) {
    var that = this;
    that.getBaseUrl = function () {
        return $window.location.protocol + '//' + $window.location.hostname + $window.location.pathname;
    };
    that.getTemplateUrl = function (componentName, templateName) {
    	return that.getBaseUrl() + 'app/components/' + componentName + '/' + (templateName || componentName) + '.html';
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumUrlService.ts